import { useQuery } from '@tanstack/react-query';
import { getClientBrands, getClientDashboard } from '@/features/completeness/completeness.api';
import { getAttentionProducts } from '../dashboard.api';

export function useDashboardCompleteness(gln: string, brandId: string) {
  return useQuery({
    queryKey: ['dashboard', 'completeness', gln, brandId],
    queryFn: () => getClientDashboard(gln, brandId === '' ? undefined : { brandId }),
    enabled: gln !== '',
  });
}

export function useDashboardBrands(gln: string) {
  return useQuery({
    queryKey: ['dashboard', 'brands', gln],
    queryFn: () => getClientBrands(gln),
    enabled: gln !== '',
  });
}

export function useAttentionProducts(gln: string) {
  return useQuery({
    queryKey: ['completeness', 'attention', gln],
    queryFn: () => getAttentionProducts(gln),
    enabled: gln !== '',
  });
}
